import { ComponentProps } from 'react'
import { Schemas } from '~/api/gen'
import { ItemFooter } from '~/features/shared/components/Card/ItemFooter'

const getItemAltTitle = (
  itemName: string,
  categoryName: string | undefined
) => {
  const hasItem = itemName !== ''
  if (!hasItem && categoryName) return `「${categoryName}」`
  if (hasItem && !categoryName) return `「${itemName}」`
  if (hasItem && categoryName) return `「${itemName}(${categoryName})」`
  return ''
}

const getItemAltBrand = (
  brandName: string | undefined,
  brandKana: string | null | undefined
) => {
  if (!brandName) return ''
  if (!brandKana) return `${brandName}の`
  return `${brandName}(${brandKana})の`
}

// eslint-disable-next-line complexity
export const convertToItemProps = (
  coordinateItem: Schemas.coordinate_item_small
): ComponentProps<typeof ItemFooter> => {
  const title =
    coordinateItem.name ??
    getItemAltTitle(
      coordinateItem.item_category?.name ?? '',
      coordinateItem.item_child_category?.name ||
        coordinateItem.item_category?.name
    )
  const brand = getItemAltBrand(
    coordinateItem.brand?.name,
    coordinateItem.brand?.name_kana
  )

  return {
    href:
      coordinateItem.item_id != null
        ? `/item/${coordinateItem.item_id}/`
        : `/snapitem/${coordinateItem.id}/`,
    name: title,
    category:
      coordinateItem.item_child_category?.name ||
      coordinateItem.item_category?.name ||
      '',
    brand: {
      name: coordinateItem.brand?.name || '',
      kana: coordinateItem.brand?.name_kana || '',
    },
    price: coordinateItem.display_price,
    size: coordinateItem.size ?? '',
    imageUrl: coordinateItem.image?.url_125 || '',
    imageAlt: `${brand}${title}`,
  }
}
